import React from 'react';

import UserCards from '../user-cards';
import JoinTeamModal from '../join-team-modal';
import ThanksModal from '../thanks-modal';
import ServerApi from '../../services/server-api-service';
import SeoService from '../../services/seo-service';
import Parser from 'html-react-parser';
import './our-team-page-style.css'
import HOne from "../h-one";
import Helmet from 'react-helmet';
import { motion } from 'framer-motion';
class OurTeamPage extends React.Component {
    serverApi = new ServerApi();
    seoService = new SeoService();
    constructor(props) {
        super(props);
        this.state = {
            debug: true,
            isVisibleModal: false,
            isVisibleThanksModal: false,
            selectedLanguage:"all",
            teamList: [],
            pageTeam: [],
            languages: []
        }
        this.handleModal = this.handleModal.bind(this);
        this.handleThanksModal = this.handleThanksModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentWillMount() {
        if(this.props.saveState) this.props.saveState({currentPage:'OurTeamPage'})
        if (this.state.debug) {
            console.log("componentWillMount ... -> Component: OurTeamPage");
        }

        this.serverApi.getTeamPageInfo()
            .then((data) => {
                if (this.state.debug) {
                    console.log(`getTeamPageInfo data:`, data);
                }
                this.setState({
                    ...this.state,
                    pageTeam: data,
                    teamList: data,
                    languages:  [...new Set(
                        data.flatMap(agent => agent.languages_prefix || "")
                    )]
                })
                
            })
            .catch((error) => {
                console.log(`ERROR: fetch getTeamPageInfo ... -> Component: OurTeamPage ERROR:${error}`);
            })
    }

    handleModal() {
        this.setState((state) => {
            return {
                isVisibleModal: !state.isVisibleModal,
                isVisibleThanksModal: false
            }
        });
    }

    handleThanksModal() {
        this.setState({
            isVisibleModal: false,
            isVisibleThanksModal: true
        });
    }

    selectLanguage(lang){
        let { dictionary,country, width} = this.props;
        let {isShortEmail, pageTeam,selectedLanguage} = this.state;
        if(selectedLanguage == lang){
            this.setState({
                ...this.state,
                selectedLanguage:'all',
                teamList: pageTeam
            })
        }else{
            let teamList = pageTeam.filter(agent => agent.type =='s' && agent.languages_prefix.includes(lang));
            this.setState({
                ...this.state,
                selectedLanguage:lang,
                teamList: teamList
            })
        }
       


    }

    closeModal() {
        this.setState({
            isVisibleModal: false,
            isVisibleThanksModal: false,
        })
    }

    renderLanguageList(){
        let { dictionary,country, width} = this.props;
        let {isShortEmail, pageTeam, teamList, languages, selectedLanguage} = this.state;
        let list = [];

        let counter = 0;

        list = dictionary.team_separator_object.map((lang, index, arr) => {
            if(languages.includes(lang.prefix)){
                counter++;
                return (
                    <>

                        {counter != 1 && " | "}

                        <span 
                            style={selectedLanguage == lang.prefix ? {fontSize:'19px'} :{}}
                            onClick={this.selectLanguage.bind(this, lang.prefix)}
                            >
                            {lang.value}
                        </span>
                        {/* {index < arr.length - 1 && " | "} */}
                        
                    </>
                )
            }
        });

        list = list.filter(Boolean);

        return( list );
    }



    render() {
        
        const pageLogo = require('../../elements/images/our_team_page.jpg');
        let { dictionary,country, width} = this.props;
        let {isShortEmail, pageTeam, teamList} = this.state;
        let parsedTeamDesc=Parser(dictionary.team_desc)
        return (
            <div className={"OurTeamPage MenuSpace"}>
              <Helmet>
                    <title> {dictionary.our_team} | Smart Luxe</title>
                    <meta name="description" content={parsedTeamDesc[0]} />
                    {this.seoService.insertHrefLangTags(
                                    {
                                        path: `/team`,
                                       
                                    })
                                }
                </Helmet>
                <div className="PageLogo">
                    <img id="PageLogoImg" src={pageLogo} alt='logo'></img>
                    <div id="PageLogoTitle">
                        <HOne tag='h1' title={dictionary.our_team} line={width > 600 ? "lagre" : "normal"} addclass={"lagresize"} />

                    </div>
                </div>
                <div className="OurTeamPageTopLine">
                    <div className="OurTeamPageTop">
                        {parsedTeamDesc}
                    </div>
                    <div className="OurTeamPageSeparator">
                        <h2>
                            {/* {dictionary.team_separator} */}
                            {this.renderLanguageList()}

                        </h2>
                    </div>
                </div>
                <div className="OurTeamPageBody">

                    <div className="PageBody">
                     
                        <UserCards
                            data={teamList}
                            teamCard={true}
                            dictionary={dictionary}
                            handleModal={this.handleModal}
                        />
                    </div>
                </div>
                <JoinTeamModal
                    dictionary={dictionary}
                    handleModal={this.handleModal}
                    isVisible={this.state.isVisibleModal}
                    country={country}
                    openThanksModal={this.handleThanksModal}
                />
                <ThanksModal
                    isVisible={this.state.isVisibleThanksModal}
                    title={dictionary.thank_you}
                    message={dictionary.thank_you_short}
                    closeModal={this.closeModal}
                />
            </div>
        )
    }

}

export default OurTeamPage;